// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"110":"95a8d74d","587":"9ce7f615"}[chunkId] + ".chunk.css";
};